import { render, staticRenderFns } from "./HealthQuoteSummary.vue?vue&type=template&id=35cdc424"
import script from "./HealthQuoteSummary.vue?vue&type=script&lang=js"
export * from "./HealthQuoteSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports